"use client"
import { useEffect, useRef } from "react"

export const FormCode = ({data, id}) => {

    const sectionRef = useRef(null);
    
    useEffect(() => {
        // Wait for DOM to be ready
        if (typeof window === 'undefined') return;
        if (!sectionRef.current) return;
        
        // Validate data structure
        if (!data?.form_code?.src) {
            console.error('FormCode: Missing src in data.form_code', data);
            return;
        }
        
        // Check if script already exists
        const existingScript = sectionRef.current.querySelector(`script[src="${data.form_code.src}"]`);
        if (existingScript) {
            console.log('FormCode: Script already exists');
            return;
        }
        
        // Create script element with dynamic values - matching exact HTML that works
        const script = document.createElement('script');
        script.src = data.form_code.src;
        script.setAttribute('data-account-code', data.form_code.data_account_code);
        script.setAttribute('data-signup-id', data.form_code.data_signup_id);
        
        // Append script to the section
        sectionRef.current.appendChild(script);
        console.log('FormCode: Script injected into section');
        console.log('FormCode: Script src:', script.src);
        console.log('FormCode: Script attributes:', {
            'data-account-code': script.getAttribute('data-account-code'),
            'data-signup-id': script.getAttribute('data-signup-id')
        });
        
    }, [data?.form_code?.src, data?.form_code?.data_account_code, data?.form_code?.data_signup_id, id]);
    
    return (
        <section ref={sectionRef} id={`form-code-section-${id}`}>
            {/* Script will be injected here */}
        </section>
    );
}
